





































import Vue from 'vue'
import AppDialog from '~/components/AppDialog.vue'
import { Role } from '../../../shared/Role'
import { isAdminOrTrialAdmin } from '~/middleware/isAdmin'

export default Vue.extend({
  components: {
    AppDialog,
  },
  middleware: isAdminOrTrialAdmin,
  //value prop is the value of v-model
  props: ['selectedUserInvite', 'value'],
  data: () => ({
    userInvite: { email: 'loading...', userInvite: { id: 'loading' } },
    Role,
  }),
  watch: {
    // to have child props dynamically change with parent input, watch the prop and assign it to local variable defined in data
    selectedUserInvite() {
      this.userInvite = this.selectedUserInvite
    },
  },
  methods: {
    async handleDeleteUserInvite(): Promise<void> {
      const confirmationText =
        'Are you sure you want to delete this user invite?'
      const confirmationPrompt =
        'Type the email of the invitation you want to delete: '
      const email = window.prompt(confirmationPrompt)
      if (email !== this.userInvite.email) {
        this.$toast.error('Wrong email.')
        return
      }
      if (window.confirm(confirmationText)) {
        // PERMANENTLY DELETE the invitation
        try {
          await this.$axios.delete(
            `user-invite/delete?inviteId=${this.userInvite.userInvite.id}`
          )
          this.$emit('deleteUserInvite', this.userInvite)
          this.$emit('input', false)
        } catch (e) {
          this.$toast.error('Unable to delete the invitation.' + e.message)
        }
      }
    },
  },
})
